import(/* webpackMode: "eager" */ "/home/i2k2admin/RestroAgent/RestroAgent/src/app/(landing)/privacy/page.tsx");
